import { defineMessages } from 'react-intl';

export default defineMessages({
  headingBlockTitle: {
    id: 'pages.confirmSignUp.headingBlockTitle',
    defaultMessage: 'Almost done',
  },
  headingBlockLeadText: {
    id: 'pages.confirmSignUp.headingBlockLeadText',
    defaultMessage: "Let's finalise a few details and get you set up.",
  },
});
